import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQlQuery,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { IPayPalOrder } from '../../../../model';

import { decodePayPalOrder } from './decoder';
import { GET_PAYPAL_ORDER_QUERY } from './getPayPalOrderQuery';
import { IGetPayPalOrderResponse } from './model';

export const useGetPayPalOrder = (): IHttpHookResponseAwaitable<IGeneralRequestResponse<IPayPalOrder>, string> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IPayPalOrder>,
    IGraphQlQuery,
    IGetPayPalOrderResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EPaymentApiKeys.PAYMENT_PAYPAL_GET_ORDER,
    mappingFunction: decodePayPalOrder,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(
    (payPalOrderId?: string) => {
      const payload = { query: GET_PAYPAL_ORDER_QUERY };
      return awaitableRequest({
        data: payload,
        ...(payPalOrderId && { restUrlParams: [{ name: 'payPalOrderId', value: payPalOrderId }] }),
      });
    },
    [awaitableRequest],
  );

  return { request };
};
